import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { dismissUpdateBanner } from '../slicers/VersionSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const STORAGE_KEY = 'versionUpdateReloadAt';
const SUPPRESS_BANNER_MS = 90 * 1000; // Don't show banner again for 90s after "Update Now" reload

const UpdateBanner = () => {
    const dispatch = useDispatch();
    const { showUpdateBanner } = useSelector((state) => state.version);

    if (!showUpdateBanner) {
        return null;
    }

    // Avoid showing the banner again immediately after user clicked "Update Now" and the page reloaded
    try {
        const reloadAt = sessionStorage.getItem(STORAGE_KEY);
        if (reloadAt) {
            const elapsed = Date.now() - parseInt(reloadAt, 10);
            if (elapsed < SUPPRESS_BANNER_MS) {
                return null;
            }
            sessionStorage.removeItem(STORAGE_KEY);
        }
    } catch (e) {
        // ignore
    }

    const handleDismiss = () => {
        dispatch(dismissUpdateBanner());
    };

    const handleReload = async () => {
        // Mark that we're reloading so we don't show the banner again right after reload
        try {
            sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch (e) {
            // ignore
        }
        // Clear browser cache when available
        if ('caches' in window) {
            try {
                const cacheNames = await caches.keys();
                await Promise.all(cacheNames.map(name => caches.delete(name)));
            } catch (error) {
                console.warn('Failed to clear cache:', error);
            }
        }
        // reload(true) is deprecated and ignored; use reload() and rely on sessionStorage to avoid banner loop
        window.location.reload();
    };

    const formatBuildTime = (buildTime) => {
        if (!buildTime) return '';
        try {
            const date = new Date(buildTime);
            return date.toLocaleString();
        } catch (e) {
            return buildTime;
        }
    };

    return (
        <Alert 
            variant="info"
            className="mb-0 border-0"
            style={{
                borderRadius: 0,
                padding: '12px 20px',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#d1ecf1',
                borderColor: '#bee5eb',
                color: '#0c5460'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                <FontAwesomeIcon 
                    icon="fa-download" 
                    style={{ marginRight: '10px', fontSize: '16px' }}
                />
                <div>
                    <strong>New Version Available</strong>
                    <span style={{ marginLeft: '10px' }}>
                        Please refresh the page to update to the latest version.
                    </span>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Button 
                    variant="outline-primary" 
                    size="sm"
                    onClick={handleReload}
                    style={{ fontSize: '12px' }}
                >
                    <FontAwesomeIcon icon="fa-refresh" style={{ marginRight: '5px' }} />
                    Update Now
                </Button>
                <Button 
                    variant="outline-secondary" 
                    size="sm"
                    onClick={handleDismiss}
                    style={{ fontSize: '12px' }}
                >
                    Dismiss
                </Button>
            </div>
        </Alert>
    );
};

export default UpdateBanner;
